import styled from 'styled-components'
import { ReactComponent as Logo } from 'assets/icons/logo.svg'
import { Main } from 'pages/Main/styles'

const LogoIcon = styled(Logo)`
  width: 180px;
  max-width: 50vw;
  height: auto;
`

const CentralizedContainer = styled(Main)`
  display: flex;
  height: 100%;
  min-height: 100px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  padding: ${({ theme }) => theme.spacing(5)};
`

const TopSpacedContainer = styled.main`
  height: 80%;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
`

export { LogoIcon, CentralizedContainer, TopSpacedContainer }
